import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-menu-btn',
  imports: [],
  templateUrl: './menu-btn.component.html',
  styleUrl: './menu-btn.component.css'
})
export class MenuBtnComponent {
  @Input() open: boolean = false;

}
